// Babel IE 11 - needs es5
import "@babel/polyfill";

// Vendor
// Webpack automatically adds it to vendor bundle if the source is a node_module
import "bootstrap/less/bootstrap.less";
import "angular-aside/dist/css/angular-aside.min.css";
import "angular-loading-bar/build/loading-bar.min.css";
import "angular-hotkeys/build/hotkeys.min.css";
import "ng-image-gallery/dist/ng-image-gallery.min.css";

// Application bundle
import "./less/style.less"; //base/global theme styles
import "./assets/fonts/fontello-b7b751c8/css/fontello.css";
import "./assets/fonts/kbh-font/fonts.css";

import smoothscroll from "smoothscroll-polyfill";

// kick off the polyfill!
smoothscroll.polyfill();

import "./app.js";

if (module.hot) {
    module.hot.accept("./app.js", function () {
        console.log("Accepting the updated app module!");
        printMe();
    });
}
